(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"]) return;
  try {
    
  (function() {
    var picker = document.getElementById('bundle-picker');
    if (!picker) return;

    var maxCountEl = document.getElementById('max-count');
    var errorEl = document.getElementById('bundle-error');

    var variantId500 = picker.dataset.variant500;
    var variantId1000 = picker.dataset.variant1000;

    var errorMaxTemplate = picker.dataset.errorMax || '';
    var errorMinMessage = picker.dataset.errorMin || '';
    var errorAddMessage = picker.dataset.errorAdd || '';

    var maxAllowed = 5;

    function getVariantId() {
      var sel = document.querySelector('select[name="id"]');
      if (sel) return sel.value;
      var radio = document.querySelector('input[name="id"]:checked');
      if (radio) return radio.value;
      var hidden = document.querySelector('input[name="id"]');
      if (hidden) return hidden.value;
      return variantId500;
    }

    function updateMax() {
      var currentVariant = getVariantId();
      maxAllowed = currentVariant === variantId1000 ? 10 : 5;
      maxCountEl.textContent = maxAllowed;

      var checked = document.querySelectorAll('input[name="bundle_product"]:checked');
      if (checked.length > maxAllowed) {
        Array.prototype.slice.call(checked, maxAllowed).forEach(function(cb) {
          cb.checked = false;
          var item = cb.closest('.bundle-item');
          if (item) {
            item.classList.remove('bundle-item--selected');
          }
        });
      }
    }

    document.addEventListener('change', function(e) {
      if (e.target && e.target.name === 'id') updateMax();
    });

    Array.prototype.forEach.call(document.querySelectorAll('.bundle-item'), function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();

        var cb = item.querySelector('input[type="checkbox"]');
        if (!cb) return;

        var checked = document.querySelectorAll('input[name="bundle_product"]:checked');

        if (!cb.checked && checked.length >= maxAllowed) {
          if (errorMaxTemplate) {
            errorEl.textContent = errorMaxTemplate.replace('%max%', maxAllowed);
          }
          errorEl.style.display = 'block';
          return;
        }

        errorEl.style.display = 'none';
        cb.checked = !cb.checked;
        item.classList.toggle('bundle-item--selected', cb.checked);
      });
    });

    var addButton = document.getElementById('add-bundle-to-cart');
    if (!addButton) return;

    addButton.addEventListener('click', function() {
      var selected = document.querySelectorAll('input[name="bundle_product"]:checked');
      if (selected.length === 0) {
        errorEl.textContent = errorMinMessage;
        errorEl.style.display = 'block';
        return;
      }

      var mainVariantId = getVariantId();
      var properties = {};

      Array.prototype.forEach.call(selected, function(cb, i) {
        var container = cb.closest('.bundle-item');
        var titleEl = container ? container.querySelector('.bundle-item__title') : null;
        var label = titleEl ? titleEl.textContent : '';
        properties['Sorte ' + (i + 1)] = label;
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: mainVariantId,
          quantity: 1,
          properties: properties
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.href = '/cart'; })
      .catch(function() {
        errorEl.textContent = errorAddMessage;
        errorEl.style.display = 'block';
      });
    });

    updateMax();
  })();

  } catch(e) { console.error(e); }
})();
})();
